import produce from "immer";
import {
  ALL_MODULES_METADATA_SUCCESS,
  ALL_MODULES_UPDATE_ORDER,
} from "../../../actionTypes";
import { ModuleMetadataByIdSTORE, ModulesActionTypes } from "../../../types";

const initialState: ModuleMetadataByIdSTORE = {};

const allModulesReducer = (
  state = initialState,
  action: ModulesActionTypes
) => {
  switch (action.type) {
    case ALL_MODULES_METADATA_SUCCESS: {
      const newById: ModuleMetadataByIdSTORE = {};
      const allModulesMetadata = action.payload;

      allModulesMetadata.forEach((moduleMetadata) => {
        newById[moduleMetadata.id] = {
          ...moduleMetadata,
          isFetching: false,
        };
      });

      return newById;
    }
    case ALL_MODULES_UPDATE_ORDER: {
      const { modulesOrder } = action.payload;

      const updatedModules = produce(state, (draft) => {
        Object.entries(modulesOrder).forEach(([moduleId, order]) => {
          draft[Number(moduleId)].order = order;
        });
      });

      return updatedModules;
    }
    default:
      return state;
  }
};

export default allModulesReducer;
